/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Stan mieszkania
 * @example "GOOD"
 */
export enum BuildingConditionEnum {
  DoRemontu = "Do Remontu",
  Dobry = "Dobry",
  StanDeweloperski = "Stan Deweloperski",
  PoRemoncie = "Po Remoncie",
}

/**
 * Ogólny stan budynku
 * @example "GOOD"
 */
export enum BuildingOverallConditionEnum {
  Zly = "Zły",
  Dobry = "Dobry",
  PoRenowacji = "Po renowacji",
  BardzoDobry = "Bardzo dobry",
  Nowy = "Nowy",
}

/**
 * Typ nieruchomości
 * @example "BLOCK"
 */
export enum FlatBuildingTypeEnum {
  Blok = "Blok",
  Apartamentowiec = "Apartamentowiec",
  Kamienica = "Kamienica",
  Pozostale = "Pozostałe",
}

export interface PredictPriceDataDto {
  /**
   * Opis mieszkania
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  buildingOverallCondition: BuildingOverallConditionEnum;
  /**
   * Powierzchnia
   * @format double
   * @min 0
   */
  area: number;
  /**
   * Liczba pokoi
   * @format int32
   * @min 0
   */
  numberOfRooms: number;
  /**
   * Rok budowy
   * @format int32
   * @min 1900
   */
  builtYear: number;
  buildingType: FlatBuildingTypeEnum;
  buildingCondition: BuildingConditionEnum;
  /**
   * Piętro
   * @format int32
   * @min 0
   */
  floor: number;
  /**
   * Liczba pięter
   * @format int32
   * @min 0
   */
  floors: number;
  typeOfMarket: TypeOfMarketEnum;
  /** Numer budynku */
  buildingNumber?: string;
  /**
   * Id lokalizacji
   * @format int32
   */
  id: number;
}

/**
 * Typ rynku
 * @example "SECONDARY"
 */
export enum TypeOfMarketEnum {
  Pierwotny = "Pierwotny",
  Wtorny = "Wtórny",
}

/** Odpowiedź zawierająca zakresy cenowe dla podobnych nieruchomości */
export interface PriceRangeResponseDto {
  /**
   * Minimalna cena całkowita znaleziona w okolicy
   * @format double
   * @example 450000
   */
  minPrice?: number;
  /**
   * Maksymalna cena całkowita znaleziona w okolicy
   * @format double
   * @example 650000
   */
  maxPrice?: number;
  /**
   * Minimalna cena za m²
   * @format double
   * @example 9000
   */
  minPricePerM2?: number;
  /**
   * Maksymalna cena za m²
   * @format double
   * @example 14000
   */
  maxPricePerM2?: number;
  /**
   * Liczba podobnych ofert użytych do obliczeń
   * @format int32
   * @example 15
   */
  sampleSize?: number;
  /**
   * Bezwzględna minimalna cena całkowita (ze wszystkich znalezionych ofert)
   * @format double
   * @example 390000
   */
  rawMinPrice?: number;
  /**
   * Bezwzględna maksymalna cena całkowita (ze wszystkich znalezionych ofert)
   * @format double
   * @example 850000
   */
  rawMaxPrice?: number;
  /**
   * Bezwzględna minimalna cena za m² (ze wszystkich znalezionych ofert)
   * @format double
   * @example 7800
   */
  rawMinPricePerM2?: number;
  /**
   * Bezwzględna maksymalna cena za m² (ze wszystkich znalezionych ofert)
   * @format double
   * @example 18000
   */
  rawMaxPricePerM2?: number;
  /**
   * Całkowita liczba znalezionych ofert przed odfiltrowaniem
   * @format int32
   * @example 22
   */
  rawSampleSize?: number;
  sameCondition?: boolean;
}

/**
 * Dodatkowe informacje
 * @example "["BALCONY","GARAGE"]"
 */
export enum AdditionalInformationEnum {
  MiejsceParkingowe = "Miejsce parkingowe",
  Garaz = "Garaż",
  Balkon = "Balkon",
  Taras = "Taras",
  Ogrodek = "Ogródek",
  KomorkaLokatorska = "Komórka lokatorska",
  Piwnica = "Piwnica",
  Strych = "Strych",
  Winda = "Winda",
  Klimatyzacja = "Klimatyzacja",
  Ochrona = "Ochrona",
  TerenZamkniety = "Teren zamknięty",
}

export interface PredictPriceDataFullDto {
  /**
   * Opis mieszkania
   * @minLength 0
   * @maxLength 1000
   */
  description?: string;
  buildingOverallCondition: BuildingOverallConditionEnum;
  /**
   * Powierzchnia
   * @format double
   * @min 0
   */
  area: number;
  /**
   * Liczba pokoi
   * @format int32
   * @min 0
   */
  numberOfRooms: number;
  /**
   * Rok budowy
   * @format int32
   * @min 1900
   */
  builtYear: number;
  buildingType: FlatBuildingTypeEnum;
  buildingCondition: BuildingConditionEnum;
  /**
   * Piętro
   * @format int32
   * @min 0
   */
  floor: number;
  /**
   * Liczba pięter
   * @format int32
   * @min 0
   */
  floors: number;
  typeOfMarket: TypeOfMarketEnum;
  /** Numer budynku */
  buildingNumber?: string;
  /**
   * Id lokalizacji
   * @format int32
   */
  id: number;
  /**
   * Minimalna cenna za metr mieszkań w okolicy
   * @format double
   */
  minPricePerSquareMeter?: number;
  /**
   * Maksymalna cena cenna za metr mieszkań w okolicy
   * @format double
   */
  maxPricePerSquareMeter?: number;
  /**
   * Minimalna cena z ogłoszenia
   * @format double
   */
  minPrice?: number;
  /**
   * Maksymalna cena z ogłoszenia
   * @format double
   */
  maxPrice?: number;
  priceSearchValue: PriceSearchValue;
  /**
   * Dodatkowe informacje
   * @uniqueItems true
   * @example ["BALCONY","GARAGE"]
   */
  additionalInfo?: AdditionalInformationEnum[];
}

/**
 * Kryterium wyboru ceny
 * @example "ADVERTISEMENT_PRICE"
 */
export enum PriceSearchValue {
  CenaZaMetr = "Cena za metr",
  CenaZOgloszenia = "Cena z ogłoszenia",
}

export interface PredictionCreatedResponse {
  /** @format uuid */
  uuid?: string;
}

/** Dane do aktualizacji statusu predykcji (Webhook Payload) */
export interface PredictionStatusUpdateDto {
  /**
   * Unikalny identyfikator predykcji (UUID)
   * @format uuid
   * @example "550e8400-e29b-41d4-a716-446655440000"
   */
  uuid: string;
  /**
   * Nowy status procesu predykcji
   * @example "CALCULATING_VALUATION"
   */
  status: PredictionStatusUpdateDtoStatusEnum;
  /**
   * Opcjonalny komunikat (np. powód błędu przy statusie FAILED)
   * @minLength 0
   * @maxLength 5000
   * @example "Timeout during external API call"
   */
  message?: string;
}

/** Dane do zmiany tytułu predykcji */
export interface UpdatePredictionTitleDto {
  /**
   * Nowy tytuł/opis
   * @minLength 0
   * @maxLength 200
   * @example "Mieszkanie pod flipa - wersja 2"
   */
  newTitle: string;
}

/** Element listy historii predykcji użytkownika */
export interface UserPredictionListItemDto {
  /**
   * Identyfikator predykcji
   * @format uuid
   * @example "a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11"
   */
  uuid?: string;
  /**
   * Tytuł predykcji
   * @example "Mieszkanie pod inwestycję Mokotów"
   */
  title?: string;
  /**
   * Lokalizacja
   * @example "Warszawa, Mokotów"
   */
  location?: string;
  /**
   * Data utworzenia zapytania
   * @format date-time
   */
  createdAt?: string;
  /**
   * Status przetwarzania
   * @example "COMPLETED"
   */
  status?: UserPredictionListItemDtoStatusEnum;
}

/** Aktualny status procesu predykcji */
export interface PredictionStatusDto {
  /**
   * Identyfikator predykcji
   * @format uuid
   */
  uuid?: string;
  /** Aktualny etap procesu */
  status?: PredictionStatusDtoStatusEnum;
  /**
   * Data ostatniej aktualizacji statusu
   * @format date-time
   */
  updatedAt?: string;
}

/**
 * Analiza ogłoszenia (Wykres)
 * Obiekt zawierający dane do wykresu. Tymczasowo może zwracać null.
 */
export interface AdvertisementAnalysis {
  trendResult?: string[];
  analysisAreaRows?: AnalysisAreaRow[];
  analysisTimeRows?: AnalysisTimeRow[];
}

/**
 * 6. PODSUMOWANIE AI
 * Sekcja 6 - PODSUMOWANIE AI: Skompresowane AI i Rekomendacja
 */
export interface AiSummarySectionDto {
  /**
   * Krótki opis sekcji
   * @example "Błyskawiczna rekomendacja inwestycyjna oparta na analizie wszystkich zebranych danych rynkowych."
   */
  sectionDescription?: string;
  /**
   * Podsumowanie i rekomendacja
   * Maksymalnie 2 konkretne zdania wygenerowane na podstawie liczb
   * @example "Nieruchomość wyceniona poniżej średniej rynkowej z dużym potencjałem na wynajem długoterminowy. Bezpieczna okolica z pełną infrastrukturą w promieniu 300m."
   */
  aiRecommendationText?: string;
}

export interface AnalysisAreaRow {
  /**
   * Powierzchnia tytuł
   * @example "Powierzchnia"
   */
  areaLabel: string;
  /**
   * Liczba transakcji
   * @format int32
   * @example 100
   */
  transactionAmount: number;
  /**
   * Średnia cena za m2
   * @format int32
   * @example 1000
   */
  avgPricePerSquareMeter: number;
  /**
   * Minimalna cena za m2
   * @format int32
   * @example 100
   */
  minPricePerSquareMeter: number;
  /**
   * Maksymalna cena za m2
   * @format int32
   * @example 10000
   */
  maxPricePerSquareMeter: number;
  /**
   * Mediana cena za m2
   * @format int32
   * @example 1000
   */
  medianPricePerSquareMeter: number;
  /**
   * Odchylenie standardowe cena za m2
   * @format int32
   * @example 1000
   */
  sdPricePerSquareMeter: number;
  /**
   * Średnia cena
   * @format int32
   * @example 1000
   */
  avgPrice: number;
  /**
   * Minimalna cena
   * @format int32
   * @example 100
   */
  minPrice: number;
  /**
   * Maksymalna cena
   * @format int32
   * @example 10000
   */
  maxPrice: number;
  /**
   * Mediana cena
   * @format int32
   * @example 1000
   */
  medianPrice: number;
  /**
   * Odchylenie standardowe cena
   * @format int32
   * @example 1000
   */
  sdPrice: number;
}

export interface AnalysisTimeRow {
  /**
   * Okres czasowy tytuł
   * @example "Tytuł czasowy"
   */
  timeRangeLabel: string;
  /**
   * Liczba transakcji
   * @format int32
   * @example 100
   */
  transactionAmount: number;
  /**
   * Średnia powierzchnia
   * @format int32
   * @example 100
   */
  avgArea: number;
  /**
   * Minimalna powierzchnia
   * @format int32
   * @example 10
   */
  minArea: number;
  /**
   * Maksymalna powierzchnia
   * @format int32
   * @example 1000
   */
  maxArea: number;
  /**
   * Odchylenie standardowe powierzchnia
   * @format int32
   * @example 100
   */
  sdArea: number;
  /**
   * Średnia cena za m2
   * @format int32
   * @example 1000
   */
  avgPricePerSquareMeter: number;
  /**
   * Minimalna cena za m2
   * @format int32
   * @example 100
   */
  minPricePerSquareMeter: number;
  /**
   * Maksymalna cena za m2
   * @format int32
   * @example 10000
   */
  maxPricePerSquareMeter: number;
  /**
   * Mediana cena za m2
   * @format int32
   * @example 1000
   */
  medianPricePerSquareMeter: number;
  /**
   * Odchylenie standardowe cena za m2
   * @format int32
   * @example 1000
   */
  sdPricePerSquareMeter: number;
  /**
   * Średnia cena
   * @format int32
   * @example 1000
   */
  avgPrice: number;
  /**
   * Minimalna cena
   * @format int32
   * @example 100
   */
  minPrice: number;
  /**
   * Maksymalna cena
   * @format int32
   * @example 10000
   */
  maxPrice: number;
  /**
   * Mediana cena
   * @format int32
   * @example 1000
   */
  medianPrice: number;
  /**
   * Odchylenie standardowe cena
   * @format int32
   * @example 1000
   */
  sdPrice: number;
  /** Lista wzrostu */
  growthList: PairStringBoolean[];
}

/**
 * 1. HERO SECTION (Wynik Wyceny i Ocena Okazji)
 * Sekcja 1 - Hero Section: Wynik Wyceny i Ocena Okazji
 */
export interface HeroSectionDto {
  /**
   * Krótki opis sekcji
   * @example "Analiza wartości nieruchomości na podstawie unikalnych parametrów i aktualnej sytuacji rynkowej."
   */
  sectionDescription?: string;
  /** Parametry wycenianego mieszkania wyświetlane w sekcji Hero */
  propertyParams?: ValuatedPropertyParamsDto;
  /**
   * Wskaźnik Atrakcyjności
   * Ogólna ocena inwestycji w skali 0-10
   * @format double
   * @example 8.5
   */
  attractivenessScore?: number;
  /** Wyraźny znacznik statusu rynkowego */
  marketBargainLabel?: MarketBargainLabelEnum;
  /**
   * Szacowana wartość całkowita - Minimum
   * @format double
   * @example 455000
   */
  estimatedPriceTotalMin?: number;
  /**
   * Szacowana wartość całkowita - Maksimum
   * @format double
   * @example 485000
   */
  estimatedPriceTotalMax?: number;
  /**
   * Szacowana wartość za m² - Minimum
   * @format double
   * @example 7000
   */
  estimatedPricePerSqmMin?: number;
  /**
   * Szacowana wartość za m² - Maksimum
   * @format double
   * @example 7460
   */
  estimatedPricePerSqmMax?: number;
}

/**
 * Wyróżnione punkty POI (Rząd ikon)
 * Pojedynczy wyróżniony punkt POI do wyświetlenia w rzędzie ikon
 */
export interface HighlightedPoiDto {
  /**
   * Nazwa punktu
   * @example "Przystanek"
   */
  name?: string;
  /**
   * Odległość
   * @example "150 m"
   */
  distance?: string;
  /** Twardy kontrakt dla frontendu do wyświetlenia odpowiedniej grafiki */
  iconType?: PoiIconTypeEnum;
}

/**
 * Dane do wykresu słupkowego - Powierzchnia
 * Dane pojedynczego słupka na histogramie kontekstu rynkowego
 */
export interface HistogramBarDto {
  /**
   * Etykieta przedziału
   * Wyświetlana na osi X
   * @example "7k - 8k"
   */
  rangeLabel?: string;
  /**
   * Dolna granica przedziału
   * Oś X min
   * @format double
   * @example 7000
   */
  rangeMin?: number;
  /**
   * Górna granica przedziału
   * Oś X max
   * @format double
   * @example 8000
   */
  rangeMax?: number;
  /**
   * Liczba ofert w przedziale
   * Wartość na osi Y
   * @format int32
   * @example 15
   */
  offerCount?: number;
  /**
   * Czy to przedział wycenianego mieszkania?
   * Służy do nadania mocnego koloru temu konkretnemu słupkowi na wykresie, podczas gdy reszta jest wyszarzona
   * @example true
   */
  isSubjectPropertyRange?: boolean;
}

/**
 * Pełne dane POI
 * Zestawienie odległości do najważniejszych punktów infrastruktury (POI) wokół lokalizacji. Formatowane dynamicznie: < 1km z dokładnością do 10m, < 10km z dokładnością do 2 miejsc po przecinku, >= 10km z dokładnością do 1 miejsca po przecinku. Brak obiektu to 'Brak danych'.
 */
export interface LocationPoiDto {
  /**
   * Odległość do centrum miasta/miejscowości
   * @example "2.50 km"
   */
  cityCenter?: string;
  /**
   * Odległość do najbliższego przedszkola
   * @example "350 m"
   */
  kindergarten?: string;
  /**
   * Odległość do najbliższej szkoły
   * @example "800 m"
   */
  school?: string;
  /**
   * Odległość do najbliższej szkoły wyższej (uczelni)
   * @example "4.50 km"
   */
  university?: string;
  /**
   * Odległość do najbliższego supermarketu
   * @example "400 m"
   */
  supermarket?: string;
  /**
   * Odległość do najbliższej galerii handlowej
   * @example "3.20 km"
   */
  shoppingMall?: string;
  /**
   * Odległość do najbliższego przystanku autobusowego
   * @example "150 m"
   */
  busStop?: string;
  /**
   * Odległość do najbliższego przystanku tramwajowego
   * @example "450 m"
   */
  tramStop?: string;
  /**
   * Odległość do najbliższej stacji/przystanku kolejowego
   * @example "1.20 km"
   */
  trainStation?: string;
  /**
   * Odległość do najbliższych torów kolejowych (uciążliwość hałasowa)
   * @example "800 m"
   */
  railwayTracks?: string;
  /**
   * Odległość do najbliższej autostrady
   * @example "15.0 km"
   */
  highway?: string;
  /**
   * Odległość do najbliższej drogi ekspresowej
   * @example "5.00 km"
   */
  expressway?: string;
  /**
   * Odległość do najbliższego lotniska międzynarodowego
   * @example "25.0 km"
   */
  majorAirport?: string;
  /**
   * Odległość do małego lotniska (regionalnego/prywatnego)
   * @example "12.0 km"
   */
  minorAirport?: string;
  /**
   * Odległość do lotniska wojskowego
   * @example "Brak danych"
   */
  militaryAirport?: string;
  /**
   * Odległość do najbliższej rzeki
   * @example "1.50 km"
   */
  river?: string;
  /**
   * Odległość do najbliższego jeziora
   * @example "3.00 km"
   */
  lake?: string;
  /**
   * Odległość do morza (linii brzegowej)
   * @example "350.0 km"
   */
  sea?: string;
  /**
   * Odległość do innego zbiornika wodnego (staw, basen)
   * @example "400 m"
   */
  otherWaterBody?: string;
  /**
   * Odległość do najbliższego szpitala
   * @example "4.00 km"
   */
  hospital?: string;
  /**
   * Odległość do najbliższej przychodni/gabinetu lekarskiego
   * @example "600 m"
   */
  clinic?: string;
  /**
   * Odległość do najbliższego parku lub skweru
   * @example "200 m"
   */
  park?: string;
  /**
   * Odległość do lasu
   * @example "1.50 km"
   */
  forest?: string;
  /**
   * Odległość do cmentarza
   * @example "1.00 km"
   */
  cemetery?: string;
  /**
   * Odległość do zakładu produkcyjnego/przemysłowego
   * @example "3.00 km"
   */
  industrialZone?: string;
  /**
   * Odległość do głównej linii energetycznej wysokiego/średniego napięcia
   * @example "800 m"
   */
  powerLine?: string;
  /**
   * Odległość do remizy strażackiej (potencjalny hałas syren)
   * @example "2.00 km"
   */
  fireStation?: string;
  /**
   * Odległość do wysypiska śmieci / punktu utylizacji
   * @example "Brak danych"
   */
  landfill?: string;
}

/**
 * 5. LOKALIZACJA I ATRAKCYJNOŚĆ
 * Sekcja 5 - LOKALIZACJA I ATRAKCYJNOŚĆ
 */
export interface LocationSectionDto {
  /**
   * Krótki opis sekcji
   * @example "Doskonała infrastruktura w zasięgu spaceru i szybki dojazd do kluczowych węzłów komunikacyjnych."
   */
  sectionDescription?: string;
  /**
   * Wyróżnione punkty POI (Rząd ikon)
   * Lista 3-5 najważniejszych punktów wyciągniętych z bazy, podanych z typem enuma dla łatwego renderowania ikon
   */
  highlightedPois?: HighlightedPoiDto[];
  /**
   * Czasy dojazdu do kluczowych punktów
   * Np. dojazd do centrum, na dworzec główny
   */
  travelTimes?: TravelTimeDto[];
  /** Zestawienie odległości do najważniejszych punktów infrastruktury (POI) wokół lokalizacji. Formatowane dynamicznie: < 1km z dokładnością do 10m, < 10km z dokładnością do 2 miejsc po przecinku, >= 10km z dokładnością do 1 miejsca po przecinku. Brak obiektu to 'Brak danych'. */
  allPois?: LocationPoiDto;
}

/**
 * Kafelek 1 - Wynajem Długoterminowy
 * Dane dla wynajmu długoterminowego (Kafelek 1)
 */
export interface LongTermRentalDto {
  /**
   * Krótki opis AI
   * @example "Stabilny zysk. Nieruchomość idealna pod wynajem dla studentów lub młodych par."
   */
  aiDescription?: string;
  /**
   * Szacowany miesięczny czynsz - Minimum
   * @format double
   * @example 2500
   */
  rentPriceMin?: number;
  /**
   * Szacowany miesięczny czynsz - Maksimum
   * @format double
   * @example 2800
   */
  rentPriceMax?: number;
  /**
   * Prosta stopa zwrotu (ROI brutto) w %
   * (Roczny czynsz / wycena nieruchomości) * 100
   * @format double
   * @example 6.5
   */
  roi?: number;
}

/**
 * Pinezki na mapie ogłoszeń
 * Dane pojedynczej pinezki na mapie w sekcji Dowodu Rynkowego
 */
export interface MapPinDto {
  /**
   * Id ogłoszenia, do którego odnosi się pinezka
   * @format int64
   * @example 12345
   */
  advertisementId: number;
  /**
   * Zaszyfrowany identyfikator ogłoszenia, używany do generowania linku do ogłoszenia
   * @example "abcde12345"
   */
  encryptedId: string;
  /**
   * Szerokość geograficzna
   * @format double
   * @example 50.06465
   */
  latitude?: number;
  /**
   * Długość geograficzna
   * @format double
   * @example 19.94498
   */
  longitude?: number;
  /**
   * Czy to wyceniane mieszkanie?
   * True dla centralnej, wyróżnionej pinezki, false dla referencyjnych
   * @example false
   */
  isSubjectProperty?: boolean;
  /**
   * Wyświetlana cena za m² na dymku (etykieta)
   * @example "7.2k/m²"
   */
  displayPricePerSqm?: string;
  /**
   * Adres do tooltipa
   * @example "ul. Długa 12, Kraków"
   */
  address?: string;
  /**
   * Metraż do tooltipa
   * @format double
   * @example 55.5
   */
  area?: number;
  /**
   * Cena całkowita do tooltipa
   * @format double
   * @example 450000
   */
  totalPrice?: number;
}

/**
 * Label Okazji
 * Wyraźny znacznik statusu rynkowego
 */
export enum MarketBargainLabelEnum {
  PonizejRynku = "Poniżej rynku",
  WCenieRynkowej = "W cenie rynkowej",
  PowyzejRynku = "Powyżej rynku",
}

/**
 * 3. KONTEKST RYNKOWY (Histogram)
 * Sekcja 3 - KONTEKST RYNKOWY: Histogram rozkładu cen i powierzchni
 */
export interface MarketContextSectionDto {
  /**
   * Krótki opis sekcji
   * @example "Rozkład cen ofertowych oraz metraży na lokalnym rynku, pokazujący pozycję Twojej nieruchomości na tle konkurencji."
   */
  sectionDescription?: string;
  /**
   * Promień analizy w kilometrach
   * Promień wyszukiwania ofert użytych do histogramu
   * @format double
   * @example 1.5
   */
  radiusInKm?: number;
  /**
   * Dane do wykresu słupkowego - Ceny
   * Rozkład cen za m² w okolicy w ustalonym promieniu
   */
  histogramData?: HistogramBarDto[];
  /**
   * Dane do wykresu słupkowego - Powierzchnia
   * Rozkład powierzchni w m² w okolicy w ustalonym promieniu
   */
  areaHistogramData?: HistogramBarDto[];
}

/**
 * Pozostałe oferty z okolicy
 * Reprezentuje pojedynczy wiersz w posortowanej tabeli Dowodu Rynkowego
 */
export interface MarketOfferTableRowDto {
  /**
   * Id ogłoszenia, do którego odnosi się pinezka
   * @format int64
   * @example 12345
   */
  advertisementId: number;
  /**
   * Zaszyfrowany identyfikator ogłoszenia, używany do generowania linku do ogłoszenia
   * @example "abcde12345"
   */
  encryptedId: string;
  /**
   * Czy to wyceniane mieszkanie?
   * Służy frontendowi do pogrubienia i wyróżnienia wiersza kolorem
   * @example true
   */
  isSubjectProperty?: boolean;
  /**
   * Adres
   * @example "ul. Karmelicka"
   */
  address?: string;
  /**
   * Metraż
   * @format double
   * @example 55.5
   */
  area?: number;
  /**
   * Piętro
   * @example "2/4"
   */
  floor?: string;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Stan budynku
   * @example "VERY_GOOD"
   */
  buildingCondition?: string;
  /**
   * Rodzaj zabudowy
   * @example "BLOCK"
   */
  buildingType?: string;
  /**
   * Rynek
   * @example "SECONDARY"
   */
  typeOfMarket?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2015
   */
  builtYear?: number;
  /**
   * Cena całkowita
   * @format double
   * @example 450000
   */
  totalPrice?: number;
  /**
   * Cena za m²
   * Po tej kolumnie cała tabela powinna być twardo posortowana
   * @format double
   * @example 8108
   */
  pricePerSqm?: number;
  /**
   * Cena po remoncie
   * Uzupełniane tylko dla mieszkań w stanie do remontu lub dobrym
   * @format double
   * @example 520000
   */
  priceAfterRenovation?: number | null;
  /**
   * Główne zdjęcie
   * @example "https://link-do-zdjecia.pl/img.jpg"
   */
  mainImage?: string | null;
  /**
   * Liczba dni od ostatniej modyfikacji ogłoszenia
   * @format int32
   * @example 5
   */
  dayFromLastModification?: number;
}

/**
 * 2. DOWÓD RYNKOWY (Mapa i Posortowana Tabela)
 * Sekcja 3 - DOWÓD RYNKOWY: Mapa i Posortowana Tabela
 */
export interface MarketProofSectionDto {
  /**
   * Krótki opis sekcji
   * @example "Zestawienie podobnych ofert w okolicy, udowadniające rzetelność przeprowadzonej wyceny."
   */
  sectionDescription?: string;
  /** Pinezki na mapie ogłoszeń */
  mapPins?: MapPinDto[];
  /**
   * Posortowana tabela ofert
   * Lista ofert, w tym wplecione wyceniane mieszkanie, posortowana rosnąco/malejąco po cenie za m²
   */
  tableOffers?: MarketOfferTableRowDto[];
  /**
   * Pozostałe oferty z okolicy
   * Lista dodatkowych, dalszych ofert, które zostały odrzucone z TOP 10, ale mogą stanowić szerszy kontekst rynkowy
   */
  additionalTableOffers?: MarketOfferTableRowDto[];
}

/** Lista wzrostu */
export interface PairStringBoolean {
  first?: string;
  second?: boolean;
}

/**
 * 4. PLAN B (Potencjał Wynajmu)
 * Sekcja 4 - PLAN B: Potencjał Wynajmu
 */
export interface PlanBSectionDto {
  /**
   * Krótki opis sekcji
   * @example "Szacowany potencjał inwestycyjny i miesięczne przepływy pieniężne w przypadku przeznaczenia nieruchomości na wynajem."
   */
  sectionDescription?: string;
  /** Dane dla wynajmu długoterminowego (Kafelek 1) */
  longTermRental?: LongTermRentalDto;
  /** Dane dla wynajmu krótkoterminowego (Kafelek 2) */
  shortTermRental?: ShortTermRentalDto;
}

/**
 * Typ ikony
 * Twardy kontrakt dla frontendu do wyświetlenia odpowiedniej grafiki
 */
export enum PoiIconTypeEnum {
  Centrum = "Centrum",
  Przedszkole = "Przedszkole",
  Szkola = "Szkoła",
  Uczelnia = "Uczelnia",
  Supermarket = "Supermarket",
  GaleriaHandlowa = "Galeria handlowa",
  PrzystanekAutobusowy = "Przystanek autobusowy",
  PrzystanekTramwajowy = "Przystanek tramwajowy",
  StacjaKolejowa = "Stacja kolejowa",
  ToryKolejowe = "Tory kolejowe",
  Autostrada = "Autostrada",
  Lotnisko = "Lotnisko",
  Woda = "Woda",
  Szpital = "Szpital",
  Przychodnia = "Przychodnia",
  Park = "Park",
  Las = "Las",
  Cmentarz = "Cmentarz",
  StrefaPrzemyslowa = "Strefa przemysłowa",
  LiniaEnergetyczna = "Linia energetyczna",
  StrazPozarna = "Straż pożarna",
  WysypiskoSmieci = "Wysypisko śmieci",
}

/**
 * 7. WYKRES ZMIANY CENY W CZASIE
 * Sekcja 7 - WYKRES ZMIANY CENY: Analiza historyczna
 */
export interface PriceTrendSectionDto {
  /**
   * Krótki opis sekcji
   * @example "Historia zmian cen dla tego ogłoszenia lub trendów w okolicy na przestrzeni czasu."
   */
  sectionDescription?: string;
  /** Obiekt zawierający dane do wykresu. Tymczasowo może zwracać null. */
  advertisementAnalysis?: AdvertisementAnalysis;
}

/**
 * Kafelek 2 - Wynajem Krótkoterminowy
 * Dane dla wynajmu krótkoterminowego (Kafelek 2)
 */
export interface ShortTermRentalDto {
  /**
   * Krótki opis AI
   * @example "Wysoki potencjał ze względu na bliskość centrum. Szczyt obłożenia w miesiącach letnich."
   */
  aiDescription?: string;
  /**
   * Szacowana cena za dobę - Minimum
   * @format double
   * @example 150
   */
  pricePerNightMin?: number;
  /**
   * Szacowana cena za dobę - Maksimum
   * @format double
   * @example 200
   */
  pricePerNightMax?: number;
  /**
   * Szacowane średnie obłożenie w %
   * Opcjonalne, jeśli są dane w bazie
   * @format double
   * @example 70
   */
  estimatedOccupancy?: number | null;
  /**
   * Szacowany zysk miesięczny - Minimum
   * Wynikający z ceny za dobę i obłożenia
   * @format double
   * @example 3150
   */
  monthlyProfitMin?: number | null;
  /**
   * Szacowany zysk miesięczny - Maksimum
   * Wynikający z ceny za dobę i obłożenia
   * @format double
   * @example 4200
   */
  monthlyProfitMax?: number | null;
}

/**
 * Czasy dojazdu do kluczowych punktów
 * Czasy dojazdu do kluczowych miejsc z wycenianej nieruchomości
 */
export interface TravelTimeDto {
  /**
   * Cel
   * @example "Centrum / Rynek"
   */
  destination?: string;
  /**
   * Czas dojazdu samochodem
   * @example "15 min"
   */
  carTime?: string;
  /**
   * Czas dojazdu komunikacją miejską
   * @example "25 min"
   */
  transitTime?: string | null;
}

/**
 * Parametry mieszkania wycenianego
 * Parametry wycenianego mieszkania wyświetlane w sekcji Hero
 */
export interface ValuatedPropertyParamsDto {
  /**
   * Powierzchnia
   * @format double
   * @example 55.5
   */
  area?: number;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Piętro
   * @example "2"
   */
  floor?: string;
  /**
   * Rok budowy
   * @format int32
   * @example 2015
   */
  builtYear?: number;
  /**
   * Czy posiada windę?
   * @example true
   */
  hasElevator?: boolean;
  /**
   * Czy posiada miejsce postojowe?
   * @example true
   */
  hasParkingSpace?: boolean;
  /**
   * Czy posiada balkon?
   * @example true
   */
  hasBalcony?: boolean;
  /**
   * Czy posiada komórkę lokatorską?
   * @example false
   */
  hasStorageRoom?: boolean;
}

/** Główne DTO zwracające pełny wynik wyceny nieruchomości. Składa się z zagnieżdżonych sekcji tematycznych. */
export interface ValuationResultDto {
  /** Sekcja 1 - Hero Section: Wynik Wyceny i Ocena Okazji */
  heroSection?: HeroSectionDto;
  /** Sekcja 3 - DOWÓD RYNKOWY: Mapa i Posortowana Tabela */
  marketProofSection?: MarketProofSectionDto;
  /** Sekcja 3 - KONTEKST RYNKOWY: Histogram rozkładu cen i powierzchni */
  marketContextSection?: MarketContextSectionDto;
  /** Sekcja 4 - PLAN B: Potencjał Wynajmu */
  planBSection?: PlanBSectionDto;
  /** Sekcja 5 - LOKALIZACJA I ATRAKCYJNOŚĆ */
  locationSection?: LocationSectionDto;
  /** Sekcja 6 - PODSUMOWANIE AI: Skompresowane AI i Rekomendacja */
  aiSummarySection?: AiSummarySectionDto;
  /** Sekcja 7 - WYKRES ZMIANY CENY: Analiza historyczna */
  priceTrendSection?: PriceTrendSectionDto;
}

/** Szczegółowe dane historyczne użyte do wykonania predykcji */
export interface PredictionHistoryDetailsDto {
  /**
   * UUID Predykcji
   * @format uuid
   * @example "a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11"
   */
  uuid?: string;
  /**
   * Opis mieszkania
   * @example "Przytulne mieszkanie na parterze"
   */
  description?: string;
  buildingOverallCondition?: BuildingOverallConditionEnum;
  /**
   * Powierzchnia
   * @format double
   * @example 55.5
   */
  area?: number;
  /**
   * Liczba pokoi
   * @format int32
   * @example 3
   */
  numberOfRooms?: number;
  /**
   * Rok budowy
   * @format int32
   * @example 2010
   */
  builtYear?: number;
  buildingType?: FlatBuildingTypeEnum;
  buildingCondition?: BuildingConditionEnum;
  /**
   * Piętro
   * @format int32
   * @example 2
   */
  floor?: number;
  /**
   * Liczba pięter
   * @format int32
   * @example 5
   */
  floors?: number;
  typeOfMarket?: TypeOfMarketEnum;
  /**
   * Numer budynku
   * @example "12A"
   */
  buildingNumber?: string;
  /**
   * Id lokalizacji
   * @format int32
   * @example 150
   */
  locationId?: number;
  /**
   * Minimalna cenna za metr mieszkań w okolicy
   * @format double
   * @example 9000
   */
  minPricePerSquareMeter?: number;
  /**
   * Maksymalna cena cenna za metr mieszkań w okolicy
   * @format double
   * @example 12000
   */
  maxPricePerSquareMeter?: number;
  /**
   * Minimalna cena z ogłoszenia
   * @format double
   * @example 450000
   */
  minPrice?: number;
  /**
   * Maksymalna cena z ogłoszenia
   * @format double
   * @example 600000
   */
  maxPrice?: number;
  priceSearchValue?: PriceSearchValue;
  /**
   * Dodatkowe informacje
   * @uniqueItems true
   * @example ["BALCONY","GARAGE"]
   */
  additionalInfo?: AdditionalInformationEnum[];
}

export interface Pageable {
  /**
   * @format int32
   * @min 0
   */
  page?: number;
  /**
   * @format int32
   * @min 1
   */
  size?: number;
  sort?: string[];
}

/**
 * Nowy status procesu predykcji
 * @example "CALCULATING_VALUATION"
 */
export enum PredictionStatusUpdateDtoStatusEnum {
  STARTED = "STARTED",
  FETCHING_DATA = "FETCHING_DATA",
  DISPATCHING_TO_VALUATION = "DISPATCHING_TO_VALUATION",
  CALCULATING_VALUATION = "CALCULATING_VALUATION",
  GENERATING_AI_REPORT = "GENERATING_AI_REPORT",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/**
 * Status przetwarzania
 * @example "COMPLETED"
 */
export enum UserPredictionListItemDtoStatusEnum {
  STARTED = "STARTED",
  FETCHING_DATA = "FETCHING_DATA",
  DISPATCHING_TO_VALUATION = "DISPATCHING_TO_VALUATION",
  CALCULATING_VALUATION = "CALCULATING_VALUATION",
  GENERATING_AI_REPORT = "GENERATING_AI_REPORT",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

/** Aktualny etap procesu */
export enum PredictionStatusDtoStatusEnum {
  STARTED = "STARTED",
  FETCHING_DATA = "FETCHING_DATA",
  DISPATCHING_TO_VALUATION = "DISPATCHING_TO_VALUATION",
  CALCULATING_VALUATION = "CALCULATING_VALUATION",
  GENERATING_AI_REPORT = "GENERATING_AI_REPORT",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://192.168.31.12:8080";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://192.168.31.12:8080
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  aiPredictor = {
    /**
     * @description Zwraca minimalną i maksymalną cenę podobnych nieruchomości w okolicy
     *
     * @tags Predykcje danych użytkowników
     * @name GetPriceRange
     * @summary ETAP 1 - Pobranie zakresu cenowego
     * @request POST:/ai-predictor/predict/price/range
     * @secure
     */
    getPriceRange: (data: PredictPriceDataDto, params: RequestParams = {}) =>
      this.http.request<PriceRangeResponseDto, PriceRangeResponseDto>({
        path: `/ai-predictor/predict/price/range`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Tworzy predykcję ceny na podstawie danych podanych przez użytkownika
     *
     * @tags Predykcje danych użytkowników
     * @name CreatePrediction
     * @summary ETAP 2 - Tworzenie predykcji ceny
     * @request POST:/ai-predictor/predict/price/create
     * @secure
     */
    createPrediction: (data: PredictPriceDataFullDto, params: RequestParams = {}) =>
      this.http.request<PredictionCreatedResponse, object>({
        path: `/ai-predictor/predict/price/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Endpoint używany przez zewnętrzne serwisy (np. Python AI) do raportowania postępu predykcji. Nie wymaga kontekstu użytkownika.
     *
     * @tags Webhooki Predykcji
     * @name UpdateStatus
     * @summary Aktualizacja statusu procesu (Webhook)
     * @request PATCH:/ai-predictor/webhook/status
     * @secure
     */
    updateStatus: (data: PredictionStatusUpdateDto, params: RequestParams = {}) =>
      this.http.request<object, void>({
        path: `/ai-predictor/webhook/status`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Pozwala zmienić tytuł (opis) predykcji. Wymaga bycia właścicielem predykcji.
     *
     * @tags Historia predykcji użytkownika
     * @name UpdatePredictionTitle
     * @summary Aktualizacja tytułu predykcji
     * @request PATCH:/ai-predictor/history/{uuid}/title
     * @secure
     */
    updatePredictionTitle: (uuid: string, data: UpdatePredictionTitleDto, params: RequestParams = {}) =>
      this.http.request<UserPredictionListItemDto, object>({
        path: `/ai-predictor/history/${uuid}/title`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Lekki endpoint do odpytywania (polling) o aktualny status predykcji. Używaj go cyklicznie, dopóki status nie zmieni się na COMPLETED lub FAILED.
     *
     * @tags Predykcje danych użytkowników
     * @name CheckPredictionStatus
     * @summary ETAP 3 - Sprawdzenie statusu
     * @request GET:/ai-predictor/predict/price/status/{uuid}
     * @secure
     */
    checkPredictionStatus: (uuid: string, params: RequestParams = {}) =>
      this.http.request<PredictionStatusDto, object>({
        path: `/ai-predictor/predict/price/status/${uuid}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Zwraca realny HeroSection z bazy oraz mocki dla pozostałych sekcji.
     *
     * @tags Predykcje danych użytkowników
     * @name GetPredictionV2
     * @summary ETAP 4 v2 - Pobranie hybrydowej predykcji ceny
     * @request GET:/ai-predictor/predict/price/find/v2/{uuid}
     * @secure
     */
    getPredictionV2: (uuid: string, params: RequestParams = {}) =>
      this.http.request<ValuationResultDto, object>({
        path: `/ai-predictor/predict/price/find/v2/${uuid}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Zwraca dokładne dane wejściowe, jakie zostały użyte do wygenerowania wskazanej predykcji.
     *
     * @tags Historia predykcji użytkownika
     * @name GetPredictionDetails
     * @summary Szczegóły parametrów historycznej predykcji
     * @request GET:/ai-predictor/history/{uuid}/details
     * @secure
     */
    getPredictionDetails: (uuid: string, params: RequestParams = {}) =>
      this.http.request<PredictionHistoryDetailsDto, object>({
        path: `/ai-predictor/history/${uuid}/details`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description Zwraca stronicowaną listę predykcji należących do zalogowanego użytkownika.
     *
     * @tags Historia predykcji użytkownika
     * @name GetUserPredictions
     * @summary Pobranie listy predykcji użytkownika
     * @request GET:/ai-predictor/history/list
     * @secure
     */
    getUserPredictions: (
      query: {
        pageable: Pageable;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<UserPredictionListItemDto, object>({
        path: `/ai-predictor/history/list`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Trwale usuwa wskazaną predykcję z historii użytkownika. Wymaga bycia właścicielem predykcji.
     *
     * @tags Historia predykcji użytkownika
     * @name DeletePrediction
     * @summary Usuwanie predykcji
     * @request DELETE:/ai-predictor/history/{uuid}
     * @secure
     */
    deletePrediction: (uuid: string, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/ai-predictor/history/${uuid}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}
